var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "notification-wrapper" },
    [
      _c("transition", { attrs: { name: "fade", appear: "" } }, [
        _c(
          "div",
          {
            staticClass: "notification",
            class: "notification-" + _vm.notification.type,
          },
          [
            _c(
              "a",
              {
                staticClass: "close-button",
                attrs: { href: "#" },
                on: { click: _vm.close },
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "clear",
                  attrs: { icon: ["fas", "times"] },
                }),
              ],
              1
            ),
            _c(
              "a",
              {
                staticClass: "close-button mr-1",
                attrs: { href: "#" },
                on: { click: _vm.copy },
              },
              [
                _c("font-awesome-icon", {
                  staticClass: "clear",
                  attrs: { icon: ["fas", "copy"] },
                }),
              ],
              1
            ),
            _c("h3", [
              _vm._v(
                _vm._s(_vm.notification.title ? _vm.notification.title : "")
              ),
            ]),
            _vm._v(
              " " +
                _vm._s(
                  _vm.notification.text ? _vm.notification.text : "Default text"
                ) +
                " "
            ),
            _c("div", [
              _c("small", [
                _vm._v(_vm._s(_vm.notification.datetime.toUTCString())),
              ]),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }